export default __webpack_public_path__ + "static/culture-desktop-991223c0e39712720f8a015d3dc4e639.webp";